// cr 編輯群

import Image from 'next/image';

const CRTeamItem = ({ info }) => {
    if (!info) return;
    return (
        <div
            className="team-item w-[220px] flex flex-col 
    items-center text-white flex-shrink-0 
    gap-y-[24px] mb-[43px] 
    usm:w-[43vw] usm:min-w-[170px]
    "
        >
            {/* 頭貼 */}
            <div
                className="img-box w-[220px] h-[220px] 
        rounded-[500px] overflow-hidden 
        usm:w-[43vw] usm:h-[45vw] usm:min-w-[170px]"
            >
                <Image
                    alt="image"
                    width={275}
                    height={275}
                    src={`/images/cryptoread/section5/pic_${info.enName.toLowerCase()}.png`}
                />
            </div>

            {/* 內容 */}
            <div className="w-full text-center px-[10px] umd:text-center">
                <p className="text-[24px] font-400 leading-[200%] tracking-[1.3px]">
                    {info?.enName}
                </p>

                <p className="text-bd1n whitespace-nowrap">
                    [ &nbsp;
                    <span className="text-bd1m">{info?.title}</span>
                    &nbsp;
                    <span className="text-bd2n usm:text-bd1m">{info?.subtitle}</span>
                    &nbsp; ]
                </p>
            </div>
        </div>
    );
};

export default CRTeamItem;
